import { Button, Menu, MenuButton, MenuItem, MenuList } from '@chakra-ui/react';
import {
  EditIcon,
  LoadingIcon,
  MoreIcon,
  NoDisplayIcon,
  SyncIcon,
  TrashIcon,
} from '~components/ui/icons';
import { PowerScheduleDetail_PowerScheduleFragment } from './__generated__/PowerScheduleDetail.graphql';

type Props = {
  powerSchedule: PowerScheduleDetail_PowerScheduleFragment;
  onRemoveDisplays: () => void;
  onSync: () => void;
  onDelete: () => void;
  onRename: () => void;
};

export function PowerScheduleDetailMoreActions({
  powerSchedule,
  onRemoveDisplays,
  onSync,
  onDelete,
  onRename,
}: Props) {
  const hasDisplays = powerSchedule.allDisplays.length > 0;
  const hasOutOfSyncDisplays = powerSchedule.outOfSyncDisplays.length > 0;
  const isSyncing = powerSchedule.syncingDisplays.length > 0;
  const isRemoving = powerSchedule.removingDisplays.length > 0;
  const isUpdating = isSyncing || isRemoving;

  return (
    <Menu>
      <MenuButton as={Button} aria-label="Options" variant="outline">
        <MoreIcon />
      </MenuButton>
      <MenuList>
        <MenuItem icon={<EditIcon />} onClick={onRename}>
          Rename
        </MenuItem>
        <MenuItem
          icon={isSyncing ? <LoadingIcon /> : <SyncIcon />}
          isDisabled={isUpdating || !hasOutOfSyncDisplays}
          onClick={onSync}
        >
          Sync
        </MenuItem>
        <MenuItem
          icon={isRemoving ? <LoadingIcon /> : <NoDisplayIcon />}
          isDisabled={isUpdating || !hasDisplays}
          onClick={onRemoveDisplays}
        >
          Remove from displays
        </MenuItem>
        <MenuItem
          icon={<TrashIcon color="red.500" />}
          color={'red.500'}
          isDisabled={isUpdating}
          onClick={onDelete}
        >
          Delete
        </MenuItem>
      </MenuList>
    </Menu>
  );
}
